import { render, staticRenderFns } from "./SettlementsByPayeeTable.vue?vue&type=template&id=5ae42852&scoped=true&"
import script from "./SettlementsByPayeeTable.vue?vue&type=script&lang=js&"
export * from "./SettlementsByPayeeTable.vue?vue&type=script&lang=js&"
import style0 from "./SettlementsByPayeeTable.vue?vue&type=style&index=0&id=5ae42852&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae42852",
  null
  
)

export default component.exports